function Validator_number(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]'
    };

    this.data = {
	    required: 'required',
	    messageFail: 'message-fail',
	    min: 'min',
	    max: 'max',
	    rejectedValue: 'rejected-value',
	    allowFloat: 'allow-float',
		validateOnSubmit: 'validate-on-submit'
    };

    this.triggers = {
	    validate: 'i4:validate',
	    updateView: 'i4:updateView',
	    refresh: 'i4:refresh'
    };

    this.classNames = {
	    failMessage: 'fail-message'
    };

    this.init = function() {

	    // console.log('init - number');

	    this.$formParent = this.$element.parents(this.selectors.formParent);

	    this.dataRequired = this.$element.data(this.data.required);
	    this.dataMessageFail = this.$element.data(this.data.messageFail);

	    this.dataMin = this.$element.data(this.data.min);
	    this.dataMax = this.$element.data(this.data.max);
	    this.dataRejectedValue = this.$element.data(this.data.rejectedValue);
	    this.dataAllowFloat = this.$element.data(this.data.allowFloat);

		this.$formParent.trigger(this.triggers.refresh);

	    this.$element.on(this.triggers.validate, this.validate.bind(this));
		this.$element.on('keyup blur change', this.$elementChange.bind(this));

		this.validateOnSubmit = this.$formParent.length && this.$formParent.data(this.data.validateOnSubmit);
		this.prepareFailMessage();

		if (!this.validateOnSubmit) {
			this.validate();
		}
    };

    this.$elementChange = function() {
	    this.validate();
	    this.$element.trigger('i4:change');

	    this.$formParent.trigger(this.triggers.updateView);
    };

    this.validate = function() {
	    this.value = this.$element.val();

	    var isValid = i4_Validator.isValidNumber(this.value, {
		    min: this.dataMin,
		    max: this.dataMax,
		    rejectedValue: this.dataRejectedValue,
		    allowFloat: this.dataAllowFloat
	    });

	    this.$element.removeClass('invalid');
		this.$element.removeClass('valid');
		this.$failMessage.hide();

		if (isValid) {
			this.$element.addClass('valid');
		} else if (this.value != '' || this.dataRequired) {
			this.$element.addClass('invalid');

			if (this.validateOnSubmit || this.value != '') {
				this.$failMessage.show();
			} else {
				this.$failMessage.hide();
			}
		}
    };

    this.prepareFailMessage = function() {
	    this.$failMessage = $('<div></div>');

	    if (this.dataMessageFail !== undefined) {
		    this.$failMessage.
		    	addClass(this.classNames.failMessage).
		    	html(this.dataMessageFail).
		    	hide();

		    this.$element.after(this.$failMessage);
	    }
    };

}
